import React from "react";
import GoogleReviews from "../../reviews/GoogleReviews";

const reviews = [
    {
        author: "Līva Priede",
        image: "/images/reviews/liva-priede.png",
        quote: "Tomaš was a wonderful guide, we had a lot of fun! They provide a full equipement, so no need to worry about geting dirty during the visit. Place is interesting and rich of historical stories.",
    },
    {
        author: "Pavel Nesterov",
        image: "/images/reviews/pavel-nesterov.png",
        quote: "The mine is a proper thing for exploring the mining industry of a century ago. The place is safe, visitors get desinfected helmets",
    },
    {
        author: "Miha H",
        image: "/images/reviews/miha-h.png",
        excerpt:
            "Very nice old museum mine. There is quite some history. You need a guide to enter the museum.",
        quote: "Very nice old museum mine. There is quite some history. You need a guide to enter the museum. It is very nice with huge potential for further development. There is a lot of parking available and small picnic tables. Nice for families as well.",
    },
    {
        author: "neja lavric",
        image: "/images/reviews/neja-lavric.png",
        quote: "Its a small mine with around 60 minerals... You can get a private tour of the place and they serve you tea so you warm yourself... There is 10 degrees Celsius inside, so bring warm clothes 😉",
    },
    {
        author: "Marko Stor",
        image: "/images/reviews/marko-stor.png",
        quote: "Interesting real life experience",
    },
    {
        author: "Jan Deutsch",
        image: "/images/reviews/jan-deutsch.png",
        quote: "Really nice mine with great exposition and friendly staff",
    },
    {
        author: "Matej Baš",
        image: "/images/reviews/matej-bas.png",
        quote: "Great, something worth seeing.",
    },
];

function GoogleReviewsSection() {
    return (
        <GoogleReviews
            title="Experiences worth remembering"
            description="Discover how visitors experienced the underground world of the Sitarjevec Mine."
            reviews={reviews}
            labels={{
                fiveStars: "5 out of 5 stars",
                googleLink: "See all reviews on Google",
                readFullReview: "Read the full review",
            }}
        />
    );
}

export default GoogleReviewsSection;
